module.exports = __webpack_public_path__ + "dojo-toolkit.3OcnjaJu.svg";